import React, { useEffect, useState } from 'react';
import Container from '../../Container/Container';
import { get } from '../../ApiServices/ApiServices';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import moment from "moment";
import { Image, Modal } from 'antd';
import { useSelector } from 'react-redux';
import Loader from '../Component/Loader';
import { ImageUrl } from '../../ApiServices/ApiServices';

const OrderDetail = () => {
    const [data, setdata] = useState([]);
    const location = useLocation()
    const [loading, setLoading] = useState(true);
    const [statuses, setStatuses] = useState([]);
    const [isExchangeModalOpen, setIsExchangeModalOpen] = useState(false);
    const [exchangeOrders, setExchangeOrders] = useState([]);
    const [styleComments, setStyleComments] = useState({});
    console.log("Order data %%%%%%%%%%%%%%%%%%%%%%%%%% ", data)
    const navigate = useNavigate()
    const id = location.state?.orderId;
    const [lastlog, setLastlog] = useState(null);

    useEffect(() => {
        if (data?.logs?.length > 0) {
            setLastlog(data.logs[data.logs.length - 1]);
        }
    }, [data?.logs]);


    useEffect(() => {
        if (!id) {
            navigate('/'); // or show error
            return;
        }
        ViewSingleorder();
        fetchStatuses();
        // fetchExchangeOrders();
    }, [id]);
    const fetchStatuses = async () => {
        try {
            const statusApi = `get-statuses`; // Adjust the endpoint as needed
            const statusResponse = await get(statusApi);

            if (statusResponse?.data) {
                setStatuses(statusResponse.data);
            }
        } catch (err) {
            console.error('Error fetching statuses:', err);
        }
    };


    const fetchExchangeOrders = async () => {
        if (!id || !data?.order_type) return;

        try {
            const orderType = data.order_type.toLowerCase().includes("single")
                ? "single"
                : "wedding";

            const api = `get/exchange-orders/${orderType}/${id}`;

            const response = await get(api);

            if (response?.data?.exchangeOrders) {
                setExchangeOrders(response.data.exchangeOrders);
            }
        } catch (error) {
            console.error("Error fetching exchange orders:", error);
            setExchangeOrders([]);
        }
    };

    useEffect(() => {
        if (data?.order_type) {
            fetchExchangeOrders();
        }
    }, [data?.order_type]);


    const ViewSingleorder = async () => {
        try {
            setLoading(true);
            const firstApi = `view-single-order/${id}`;
            const firstResponse = await get(firstApi);

            if (firstResponse?.status == true) {
                setdata(firstResponse?.data);
            }
        } catch (err) {
            console.error('Error in first API call:', err);
            if (err?.message == "Invalid or expired token" || err?.message == "Invalid Token") {
                localStorage.removeItem('token');
                navigate('/login');
            }
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (id) {
            ViewSingleorder();
        }
    }, [id])

    const statusName = data?.status?.name?.toLowerCase();
    const isCancelled = statusName === 'cancelled';
    const isPendingCancel = statusName === 'pending cancel' || statusName === 'pendingcancel';
    const isCancelRequested = statusName === 'cancel requested' || statusName === 'cancelrequested';
    const isPendingChange = statusName === 'pending change' || statusName === 'pendingchange';
    const isChangeRequested = statusName === 'change requested' || statusName === 'changerequested';
    const isPrinted = statusName === 'printed';
    const isBagged = statusName === 'bagged';
    const isShipped = statusName === 'shipped';
    const isChanged = statusName === 'changed';

    const normalize = (str) => str?.toLowerCase().replace(/\s/g, '');

    const wentThroughFlow = (flowType) => {
        if (!data?.logs || data?.logs.length === 0) return false;

        const flowStatuses = flowType === 'cancel'
            ? ['cancel requested', 'cancelrequested', 'pending cancel', 'pendingcancel']
            : ['change requested', 'changerequested', 'pending change', 'pendingchange'];

        return data?.logs.some(log =>
            flowStatuses.includes(normalize(log.new_data))
        );
    };

    const wentThroughCancelFlow = wentThroughFlow('cancel');
    const wentThroughChangeFlow = wentThroughFlow('change');

    const allowedStatuses = ['pending', 'open', 'ordered', 'printed', 'bagged', 'shipped'];
    const allowedStatusesWhenCancelled = ['pending', 'open', 'cancelled'];
    const earlyCancelledStatuses = ['pending', 'open', 'ordered', 'cancelrequested', 'pendingcancel', 'cancelled'];
    const changeStatuses = ['pending', 'open', 'ordered', 'changerequested', 'pendingchange', 'changed', 'printed', 'bagged', 'shipped'];

    const printedAfterCancelFlow = ['pending', 'open', 'cancelrequested', 'pendingcancel', 'printed', 'bagged', 'shipped'];
    const printedAfterChangeFlow = ['pending', 'open', 'changerequested', 'pendingchange', 'printed', 'bagged', 'shipped'];

    const baggedAfterCancelFlow = ['pending', 'open', 'cancelrequested', 'pendingcancel', 'printed', 'bagged', 'shipped'];
    const baggedAfterChangeFlow = ['pending', 'open', 'changerequested', 'pendingchange', 'printed', 'bagged', 'shipped'];

    const shippedAfterCancelFlow = ['pending', 'open', 'cancelrequested', 'pendingcancel', 'printed', 'bagged', 'shipped'];
    const shippedAfterChangeFlow = ['pending', 'open', 'changerequested', 'pendingchange', 'printed', 'bagged', 'shipped'];


    let filteredStatuses;

    // Determine which status flow to use
    if (isCancelled) {
        // Check if order went through cancel or change flow before getting cancelled
        if (wentThroughCancelFlow) {
            // Show complete cancel flow: pending → open → cancelrequested → pendingcancel → cancelled
            const cancelAfterCancelFlow = ['pending', 'open', 'cancelrequested', 'pendingcancel', 'cancelled'];
            filteredStatuses = statuses.filter(status =>
                cancelAfterCancelFlow.includes(status.name.toLowerCase()));
        } else if (wentThroughChangeFlow) {
            // Show cancel after change flow: pending → open → changerequested → pendingchange → cancelled
            const cancelAfterChangeFlow = ['pending', 'open', 'changerequested', 'pendingchange', 'cancelled'];
            filteredStatuses = statuses.filter(status =>
                cancelAfterChangeFlow.includes(normalize(status.name)));
        } else {
            // Direct cancel without any request flow: pending → open → cancelled
            filteredStatuses = statuses.filter(status =>
                allowedStatusesWhenCancelled.includes(status.name.toLowerCase()));
        }
    }
    else if (isPendingCancel || isCancelRequested) {
        filteredStatuses = statuses.filter(status =>
            earlyCancelledStatuses.includes(status.name.toLowerCase()));
    }
    else if (isPendingChange || isChangeRequested) {
        filteredStatuses = statuses.filter(status =>
            changeStatuses.includes(status.name.toLowerCase()));
    }
    else if (isChanged) {
        filteredStatuses = statuses.filter(status =>
            ['pending', 'open', 'ordered', 'cancelrequested', 'pendingcancel', 'changed', 'printed', 'bagged', 'shipped']
                .includes(normalize(status.name)));
    }
    // New cases for printed/bagged/shipped after cancel/change flows
    else if (isPrinted) {
        if (wentThroughCancelFlow) {
            filteredStatuses = statuses.filter(status =>
                printedAfterCancelFlow.includes(normalize(status.name)));
        } else if (wentThroughChangeFlow) {
            filteredStatuses = statuses.filter(status =>
                printedAfterChangeFlow.includes(normalize(status.name)));
        } else {
            filteredStatuses = statuses.filter(status =>
                allowedStatuses.includes(status.name.toLowerCase()));
        }
    }
    else if (isBagged) {
        if (wentThroughCancelFlow) {
            filteredStatuses = statuses.filter(status =>
                baggedAfterCancelFlow.includes(normalize(status.name)));
        } else if (wentThroughChangeFlow) {
            filteredStatuses = statuses.filter(status =>
                baggedAfterChangeFlow.includes(normalize(status.name)));
        } else {
            filteredStatuses = statuses.filter(status =>
                allowedStatuses.includes(status.name.toLowerCase()));
        }
    }

    else if (isShipped) {
        if (wentThroughCancelFlow) {
            filteredStatuses = statuses.filter(status =>
                shippedAfterCancelFlow.includes(normalize(status.name)));
        } else if (wentThroughChangeFlow) {
            filteredStatuses = statuses.filter(status =>
                shippedAfterChangeFlow.includes(normalize(status.name)));
        } else {
            filteredStatuses = statuses.filter(status =>
                allowedStatuses.includes(status.name.toLowerCase()));
        }
    }
    else {
        filteredStatuses = statuses.filter(status =>
            allowedStatuses.includes(status.name.toLowerCase()));
    }


    const customOrder = [
        'pending',
        'open',
        'ordered',
        'cancelrequested',
        'pendingcancel',
        'changerequested',
        'pendingchange',
        'changed',
        'cancelled',
        'printed',
        'bagged',
        'shipped'
    ];



    // if (hasPendingChange) {
    filteredStatuses = filteredStatuses.sort((a, b) => {
        const aName = normalize(a.name);
        const bName = normalize(b.name);

        const aIndex = customOrder.indexOf(aName);
        const bIndex = customOrder.indexOf(bName);

        if (aIndex !== -1 && bIndex !== -1) {
            return aIndex - bIndex; // sirf inko custom order me lagao
        }

        return 0; // baaki untouched rahenge
    });
    // }

    const getCurrentStatusIndex = () => {
        const currentStatus = normalize(data?.status?.name);

        // agar changeRequested h -> wahi last completed maana jaye
        if (currentStatus === 'changerequested') {
            return statuses.findIndex(status => normalize(status.name) === 'changerequested');
        }

        const currentStatusId = data?.status?.id;
        return statuses.findIndex(status => status.id === currentStatusId);
    };

    const { single_order_style = [] } = data;
    const coat = single_order_style.find(item => item.inventory_category_type === "Coats");
    const pant = single_order_style.find(item => item.inventory_category_type === "Pants");
    const shirt = single_order_style.find(item => item.inventory_category_type === "Shirt");
    const vest = single_order_style.find(item => item.inventory_category_type === "Vests");
    const tie = single_order_style.find(item => item.inventory_category_type === "Ties");
    const pocketSquare = single_order_style.find(item => item.inventory_category_type === "PocketSquare");
    const jewellery = single_order_style.find(item => item.inventory_category_type === "Jewellery");
    const shoes = single_order_style.find(item => item.inventory_category_type === "Shoes");

    useEffect(() => {
        if (data?.comments) {
            const text = data?.comments;
            if (text.includes("=")) {
                const parsedData = text.split(" ");
                const dataObj = {};
                parsedData.map(item => {
                    if (item.includes("=")) {
                        const splitCate = item.split("=");
                        dataObj[splitCate[0].toLowerCase()] = splitCate[1]
                    }
                });
                setStyleComments(dataObj)
            }
        }
    }, [data]);

    if (loading) {
        return (
            <Container>
                <div className="nk-content">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            <div className="nk-content-body">
                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    height: 'calc(100vh - 200px)',
                                    width: '100%',
                                    position: 'relative'
                                }}>
                                    <div style={{
                                        position: 'absolute',
                                        top: '50%',
                                        left: '50%',
                                        transform: 'translate(-50%, -50%)'
                                    }}>
                                        <Loader />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Container>
        );
    }
    return (
        <>
            <Container>
                <div class="nk-content ">
                    <div class="container-fluid">
                        <div class="nk-content-inner">
                            <div class="nk-content-body">
                                <div class="nk-block-head nk-block-head-sm">
                                    <div class="nk-block-between">
                                        <div class="nk-block-head-content">
                                            <h3 class="nk-block-title page-title">Order Detail
                                            </h3>
                                        </div>
                                        <div className="">
                                            <span
                                                onClick={() => navigate(-1)}
                                                className="btn btn-outline-light">
                                                <em class="icon ni ni-arrow-left"></em> <span> Back</span>
                                            </span>
                                        </div>
                                    </div>
                                </div>


                                <div class="card card-full orderReviewNwUpdate">
                                    <div class="card-inner">
                                        <div className="row">
                                            <div className="col-md-9">
                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <div class="form-control-wrap dateBoxWithBtn">
                                                            <div className="ordeDateButton">
                                                                <h5 class="mb-1">Order Detail</h5>
                                                                <p class="mb-0"><span class="fBold">Acc#: </span>{data?.user?.account ? data.user.account : "N/A"} </p>
                                                                <p class="mb-0"><span class="fBold">Ticket#: </span> {data?.ticket}</p>
                                                                <p class="mb-0"><span class="fBold">Order Type: </span> Single</p>
                                                                <p class="mb-0">
                                                                    <span class="fBold">Order Status: </span>
                                                                    <span class="badge openBadge text-capitalize font-revert">
                                                                        {data?.status?.name}
                                                                    </span>
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="col-md-6">
                                                        <div class="form-control-wrap dateBoxWithBtn">
                                                            <div className="ordeDateButton">
                                                                <h5 class="mb-1">Rental Timeline - {data?.rental_term}</h5>
                                                                <p class="mb-0"><span class="fBold">{moment(data?.createdAt).format("MMM D, YYYY")}:</span> Order Submitted</p>
                                                                <p class="mb-0 bg-black text-white px-2 py--1 rounded">
                                                                    <b>
                                                                        <span class="fBold ">
                                                                            {moment(data?.event_date).format("MMM D, YYYY")}:
                                                                        </span>
                                                                        Event Date
                                                                    </b>
                                                                </p>

                                                                <p class="mb-0"><span class="fBold"> {
                                                                    (() => {
                                                                        const eventDate = moment(data?.event_date);
                                                                        const currentDay = eventDate.isoWeekday(); // 1 = Monday, ..., 6 = Saturday, 7 = Sunday

                                                                        if (currentDay === 7) {
                                                                            // Sunday → Previous Saturday
                                                                            return eventDate.clone().subtract(1, "day").format("MMM D, YYYY");
                                                                        } else if (currentDay === 1) {
                                                                            // Monday → Previous Saturday
                                                                            return eventDate.clone().subtract(2, "days").format("MMM D, YYYY");
                                                                        } else if (currentDay === 6) {
                                                                            // Saturday → Current Saturday
                                                                            return eventDate.format("MMM D, YYYY");
                                                                        } else {
                                                                            // Tuesday to Friday → Upcoming Saturday
                                                                            return eventDate.clone().isoWeekday(6).format("MMM D, YYYY");
                                                                        }
                                                                    })()
                                                                }:</span>Week Ending Date</p>
                                                                <p class="mb-0 bg-black text-white px-2 py--1 rounded"><b><span class="fBold">{
                                                                    (() => {
                                                                        const eventDate = moment(data?.event_date);
                                                                        const currentDay = eventDate.isoWeekday(); // 1 = Monday, ..., 6 = Saturday, 7 = Sunday

                                                                        let weekendDate;

                                                                        if (currentDay === 7) {
                                                                            // Sunday → Previous Saturday
                                                                            weekendDate = eventDate.clone().subtract(1, "day");
                                                                        } else if (currentDay === 1) {
                                                                            // Monday → Previous Saturday
                                                                            weekendDate = eventDate.clone().subtract(2, "days");
                                                                        } else if (currentDay === 6) {
                                                                            // Saturday → Current Saturday
                                                                            weekendDate = eventDate.clone();
                                                                        } else {
                                                                            // Tuesday to Friday → Upcoming Saturday
                                                                            weekendDate = eventDate.clone().isoWeekday(6);
                                                                        }

                                                                        // Return date = Tuesday after that weekend
                                                                        return weekendDate.clone().add(3, "days").format("MMM D, YYYY");
                                                                    })()
                                                                }: </span> Return Date</b></p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <br></br>

                                            </div>
                                            <div className="col-md-3">
                                                <button className="btn btn-dark f-right" onClick={() => navigate(`/add-order`, { state: { ID: data.id, Helper: true } })}>
                                                    <em class="icon ni ni-copy"></em> Copy to new order</button>
                                            </div>
                                        </div>



                                        <ol className="c-progress-steps">
                                            {filteredStatuses.map((status, index) => {
                                                const currentStatusIndex = getCurrentStatusIndex(); // Your logic to find the current active index
                                                const stepIndex = statuses.findIndex(s => s.id == status.id);
                                                let stepClass = "";
                                                if (isChangeRequested) {
                                                    // current index in filteredStatuses
                                                    const currentStatusInFiltered = filteredStatuses.findIndex(
                                                        s => s.id === data?.status?.id
                                                    );

                                                    if (index < currentStatusInFiltered) {
                                                        stepClass = "done"; // completed before ChangeRequested
                                                    } else if (index === currentStatusInFiltered) {
                                                        stepClass = "current"; // ChangeRequested itself
                                                    }
                                                }
                                                else if (isChanged) {
                                                    // Use filteredStatuses index for "changed" flow
                                                    const currentStatusInFiltered = filteredStatuses.findIndex(
                                                        s => s.id === data?.status?.id
                                                    );

                                                    if (index < currentStatusInFiltered) {
                                                        stepClass = "done";
                                                    } else if (index === currentStatusInFiltered) {
                                                        stepClass = "current";   // Changed itself
                                                    }
                                                    // after "Changed" remains grey (default, no class)
                                                }

                                                // Special logic for pendingChange case
                                                else if (isPendingChange) {
                                                    // Find current status index in filteredStatuses array (not original statuses)
                                                    const currentStatusInFiltered = filteredStatuses.findIndex(s => s.id === data?.status?.id);

                                                    if (index < currentStatusInFiltered) {
                                                        stepClass = "done";
                                                    } else if (index === currentStatusInFiltered) {
                                                        stepClass = "current";
                                                    }
                                                }
                                                else if (isCancelled) {
                                                    if (wentThroughCancelFlow || wentThroughChangeFlow) {
                                                        // Use filtered statuses index for cancelled after cancel/change request flows
                                                        const currentStatusInFiltered = filteredStatuses.findIndex(
                                                            s => s.id === data?.status?.id
                                                        );

                                                        if (index < currentStatusInFiltered) {
                                                            stepClass = "done";
                                                        } else if (index === currentStatusInFiltered) {
                                                            stepClass = "current";
                                                        }
                                                    } else {
                                                        // Original logic for direct cancellation
                                                        if (stepIndex < currentStatusIndex) {
                                                            stepClass = "done";
                                                        } else if (stepIndex === currentStatusIndex) {
                                                            stepClass = "current";
                                                        }
                                                    }
                                                }
                                                else if (['printed', 'bagged', 'shipped'].includes(statusName)) {
                                                    if (wentThroughCancelFlow || wentThroughChangeFlow) {
                                                        const currentStatusInFiltered = filteredStatuses.findIndex(
                                                            s => s.id === data?.status?.id
                                                        );

                                                        if (index < currentStatusInFiltered) {
                                                            stepClass = "done";
                                                        } else if (index === currentStatusInFiltered) {
                                                            stepClass = "current";
                                                        }
                                                    } else {
                                                        if (stepIndex < currentStatusIndex) {
                                                            stepClass = "done";
                                                        } else if (stepIndex === currentStatusIndex) {
                                                            stepClass = "current";
                                                        }
                                                    }
                                                } else {
                                                    // Original logic for all other cases
                                                    const stepIndex = statuses.findIndex(s => s.id === status.id);
                                                    if (stepIndex < currentStatusIndex) {
                                                        stepClass = "done";
                                                    } else if (stepIndex === currentStatusIndex) {
                                                        stepClass = "current";
                                                    }
                                                }

                                                return (
                                                    <li key={status.id} className={stepClass}>
                                                        {status.name.charAt(0).toUpperCase() + status.name.slice(1)}
                                                    </li>
                                                );
                                            })}
                                        </ol>

                                        <div className="mt-3 mb-3">
                                            <button
                                                className="btn btn-custom"
                                                onClick={() => setIsExchangeModalOpen(true)}
                                            >
                                                <em className="mr-1"></em>
                                                View Exchanges
                                            </button>
                                        </div>

                                        <div class="card-title-group mb-4 ">
                                            <div class="card-tools">
                                            </div>
                                        </div>



                                        {data?.status?.name && ['cancelRequested', 'pendingCancel', 'cancelled', 'changed', 'pendingChange', 'bagged', 'printed', 'shipped'].includes(data.status.name) && (
                                            <div style={{
                                                backgroundColor: '#f7dddeff',
                                                border: '1px solid #e44a59ff',
                                                borderRadius: 6,
                                                padding: '16px',
                                                marginTop: '20px',
                                                marginBottom: '20px',
                                                color: '#d11b2dff',
                                                display: 'flex',
                                                alignItems: 'flex-start',
                                                gap: '12px'
                                            }}>
                                                <div style={{ fontSize: 20, lineHeight: '1', flexShrink: 0 }}>
                                                    <i className="fas fa-circle-info"></i>
                                                </div>

                                                <div style={{ whiteSpace: 'pre-line' }}>
                                                    <strong style={{ fontSize: 18 }}>
                                                        {[lastlog?.change_type]
                                                            .filter(Boolean)
                                                            .join('\n')}
                                                    </strong>
                                                </div>
                                            </div>
                                        )}


                                        <div className="row">
                                            <div className="col-md-4 order-md-2">
                                                <div className="eventDetailBox">
                                                    <div className="firstTitle">
                                                        <p>Customer </p>
                                                    </div>

                                                    <div className="row mt-2">
                                                        <div className="col-md-12">
                                                            <div className="row">
                                                                <div className="col-md-12">
                                                                    <p className="cutomerNAmeFonts mb-1"><em class="icon ni ni-user-alt mr-1"></em> {data?.first_name} {data?.last_name}</p>
                                                                </div>

                                                                <div className="col-md-12">
                                                                    <p className="mb-1"> <em className="icon ni ni-call  mr-1"></em> {data?.phone ? data?.phone : "N/A"}</p>
                                                                </div>
                                                                <div className="col-md-12">
                                                                    <p className="mb-0"><em className="icon ni ni-mail mr-1"></em> {data?.email ? data?.email : "N/A"}</p>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-12">
                                                                <hr></hr>
                                                            </div>
                                                            <div className="col-md-12">
                                                                <p className="mb-1"><b>Submitted by:</b> {data?.measured_by ? data?.measured_by : "N/A"}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="eventDetailBox">
                                                    <div className="firstTitle">
                                                        <p>Contact Information</p>
                                                    </div>
                                                    <div className="row mt-2">
                                                        <div className="col-md-12">
                                                            <div className="row">
                                                                <div className="col-md-12">
                                                                    <p>
                                                                        Acct: {data?.user?.account ? data.user.account : "N/A"}
                                                                    </p>
                                                                </div>
                                                                <div className="col-md-12">
                                                                    <p>
                                                                        Account Name: {data?.user?.companyName ? data.user.companyName : "N/A"}
                                                                    </p>
                                                                </div>
                                                                <div className="col-md-12">
                                                                    <p>
                                                                        Owner: {data?.user?.firstName ? `${data.user.firstName} ${data.user.lastName}` : "N/A"}
                                                                    </p>
                                                                </div>
                                                            </div>

                                                            <div className="row">
                                                                <div className="col-md-12">
                                                                    <p>
                                                                        <em className={`icon ni ${data?.user?.email ? "ni-user-alt" : "ni-alert-circle"}`} style={{ marginRight: "8px" }}></em>
                                                                        {data?.user?.email ? data.user.email : "N/A"}
                                                                    </p>
                                                                </div>
                                                                <div className="col-md-12">
                                                                    <p>
                                                                        <em className={`icon ni ${data?.user?.phone ? "ni-call" : "ni-alert-circle"}`} style={{ marginRight: "8px" }}></em>
                                                                        {data?.user?.phone ? data.user.phone : "N/A"}
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                {data?.is_alt_pickup_enable === true ? (
                                                    <div className="eventDetailBox">
                                                        <div className="firstTitle">
                                                            <p>Alternate Pickup Location</p>
                                                        </div>
                                                        <div className="row mt-2">
                                                            <div className="col-md-12">
                                                                <div className="row">
                                                                    <div className="col-md-12">
                                                                        <p><em className="icon ni ni-user-alt"></em> {data?.affiliatedStore?.firstName || ""} {data?.affiliatedStore?.lastName || ""}</p>
                                                                    </div>
                                                                    <div className="col-md-12">
                                                                        <p>
                                                                            Account:{" "}
                                                                            {data?.affiliatedStore?.account || ""}
                                                                        </p>
                                                                    </div>
                                                                    <div className="col-md-12">
                                                                        <p>
                                                                            Account Name: {" "}
                                                                            {data?.affiliatedStore?.companyName || ""}
                                                                        </p>
                                                                    </div>

                                                                    <div className="col-md-12">
                                                                        <p>
                                                                            <em className="icon ni ni-map-pin"></em>
                                                                            {data?.affiliatedStore?.addresses?.[0]?.billingAddress}
                                                                            {data?.affiliatedStore?.addresses?.[0]?.billingAddressLine2 && `, ${data?.affiliatedStore?.addresses?.[0]?.billingAddressLine2}`}
                                                                            {(data?.affiliatedStore?.addresses?.[0]?.billingCity || data?.affiliatedStore?.addresses?.[0]?.billingState) && ', '}
                                                                            {[data?.affiliatedStore?.addresses?.[0]?.billingCity, data?.affiliatedStore?.addresses?.[0]?.billingState].filter(Boolean).join(', ')}
                                                                            {data?.affiliatedStore?.addresses?.[0]?.billingZip && `, ${data?.affiliatedStore?.addresses?.[0]?.billingZip}`}
                                                                        </p>
                                                                    </div>

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ) : data?.is_drop_ship_enable === true ? (
                                                    <div className="eventDetailBox">
                                                        <div className="firstTitle">
                                                            <p>Drop Shipping</p>
                                                        </div>
                                                        <div className="row mt-2">
                                                            <div className="col-md-12">
                                                                <div className="row">
                                                                    <div className="col-md-6">
                                                                        <p><em class="icon ni ni-user-alt"></em> {data?.name ? data?.name : ""}</p>
                                                                    </div>
                                                                    <div className="col-md-6">
                                                                        <p><em class="icon ni ni-call"></em>{data?.shipping_phone ? data?.shipping_phone : ""}</p>
                                                                    </div>
                                                                    <div className="col-md-12 mt-2">
                                                                        <p>
                                                                            <em class="icon ni ni-map-pin"></em> {data ? `${data.shipping_address || ""}${data.shipping_city ? "," : ""}${data.shipping_city || ""}${data.shipping_state ? "," : ""}${data.shipping_state || ""} ${data.shipping_zip ? "-" : ""} ${data.shipping_zip || ""}`
                                                                                : ""}
                                                                        </p>                                                                </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                ) : (
                                                    <div className="eventDetailBox">
                                                        <div className="firstTitle">
                                                            <p>Shipping Address</p>
                                                        </div>
                                                        <div className="row mt-2">
                                                            <div className="col-md-12">
                                                                <div className="row">
                                                                    <div className="col-md-12">
                                                                        <p><em className="icon ni ni-user-alt"></em> {data?.user?.firstName || ""} {data?.user?.lastName || ""}</p>
                                                                    </div>
                                                                    <div className="col-md-12">
                                                                        <p>
                                                                            <em class="icon ni ni-map-pin"></em>  {data ? `${data?.user?.addresses[0]?.billingAddress || ""}${data?.user?.addresses[0]?.billingAddressLine2 ? "," : ""}${data?.user?.addresses[0]?.billingAddressLine2 || ""}${data?.user?.addresses[0]?.billingCity ? "," : ""}${data?.user?.addresses[0]?.billingCity || ""}${data?.user?.addresses[0]?.billingState ? "," : ""}${data?.user?.addresses[0]?.billingState || ""} ${data?.user?.addresses[0]?.billingZip ? "-" : ""} ${data?.user?.addresses[0]?.billingZip || ""}` : ""}
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}


                                                <div className="eventDetailBox">
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            <div className="row">
                                                                <div className="col-md-9">
                                                                    <div className="firstTitle">
                                                                        <p>Notes </p>
                                                                    </div>
                                                                    <p>{data?.comments ? data?.comments : "N/A"}</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-md-8 order-md-1">
                                                {
                                                    coat &&
                                                    <div className="eventDetailBox posRealtive">

                                                        <div className="row">
                                                            <div className="col-md-3 plNoneOrdr">
                                                                <Image
                                                                    src={coat?.inventory_category?.inventories[0]?.image
                                                                        ? `${ImageUrl}${coat?.inventory_category?.inventories[0]?.image}`
                                                                        : "/assets/images/no-photo.png"}
                                                                    className="selectCoatImgReview"
                                                                    alt=""
                                                                />
                                                            </div>
                                                            <div className="col-md-9 pRNoneOrdr">
                                                                <div className="row">
                                                                    <div className="col-md-10">
                                                                        <ul className="fstCategory mb-2 brTopNone pt-0">
                                                                            <li className="coatInfoSize">
                                                                                <span>Coat:</span> {coat?.style ? coat?.style : "N/A"} {coat?.inventory_category?.inventories[0]?.description} {styleComments?.c}
                                                                            </li>
                                                                        </ul>
                                                                    </div>
                                                                    <div className="col-md-4">
                                                                        <ul className="fstCategory mb-2 brTopNone pt-0">
                                                                            <li className="coatInfoSize">
                                                                                <span>Size:</span> {coat?.size ? coat.size : "N/A"}
                                                                                {coat?.size && coat?.size_chart_category?.name
                                                                                    ? coat.size_chart_category.name === "Short"
                                                                                        ? "S"
                                                                                        : coat.size_chart_category.name === "Long"
                                                                                            ? "L"
                                                                                            : coat.size_chart_category.name === "Extra Long"
                                                                                                ? "X"
                                                                                                : coat.size_chart_category.name === "Regular"
                                                                                                    ? "R"
                                                                                                    : coat.size_chart_category.name === "Boys"
                                                                                                        ? "B"
                                                                                                        : ""
                                                                                    : ""}
                                                                            </li>
                                                                        </ul>
                                                                    </div>
                                                                    <div className="col-md-4">
                                                                        <ul className="fstCategory mb-2 brTopNone pt-0">
                                                                            <li className="coatInfoSize">
                                                                                <span>Insleeve:</span> {coat?.insleeve ? coat.insleeve : "N/A"}
                                                                            </li>
                                                                        </ul>
                                                                    </div>

                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>}

                                                {
                                                    pant &&
                                                    <div className="eventDetailBox posRealtive">
                                                        <div className="row">
                                                            <div className="col-md-3 plNoneOrdr">
                                                                <Image
                                                                    src={pant?.inventory_category?.inventories[0]?.image
                                                                        ? `${ImageUrl}${pant?.inventory_category?.inventories[0]?.image}`
                                                                        : "/assets/images/no-photo.png"}
                                                                    className="selectCoatImgReview"
                                                                    alt=""
                                                                />
                                                            </div>
                                                            <div className="col-md-9 pRNoneOrdr">
                                                                <div className="row">
                                                                    <div className="col-md-10">
                                                                        <ul className="fstCategory mb-2 brTopNone pt-0">
                                                                            <li className="coatInfoSize">
                                                                                <span>Pant:</span> {pant?.style ? pant?.style : "N/A"} {pant?.inventory_category?.inventories[0]?.description} {styleComments?.p}
                                                                            </li>
                                                                        </ul>
                                                                    </div>
                                                                    <div className="col-md-4">
                                                                        <ul className="fstCategory mb-2 brTopNone pt-0">
                                                                            <li className="coatInfoSize">
                                                                                <span>Waist:</span> {pant?.size ? pant?.size : "N/A"}
                                                                            </li>
                                                                        </ul>
                                                                    </div>
                                                                    <div className="col-md-4">
                                                                        <ul className="fstCategory mb-2 brTopNone pt-0">
                                                                            <li className="coatInfoSize">
                                                                                <span>Outseam:</span> {pant?.outseam ? pant?.outseam : "N/A"}
                                                                            </li>
                                                                        </ul>
                                                                    </div>
                                                                    <div className="col-md-4">
                                                                        <ul className="fstCategory mb-2 brTopNone pt-0">
                                                                            <li className="coatInfoSize">
                                                                                <span>Hip:</span> {pant?.hip ? pant?.hip : "N/A"}
                                                                            </li>
                                                                        </ul>
                                                                    </div>
                                                                    {pant?.belt && (
                                                                        <div className="col-md-4">
                                                                            <ul className="fstCategory mb-2 brTopNone pt-0">
                                                                                <li className="coatInfoSize">
                                                                                    <span>Belt color:</span> {pant.belt}
                                                                                </li>
                                                                            </ul>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                }

                                                {
                                                    shirt &&
                                                    <div className="eventDetailBox posRealtive">
                                                        <div className="row">
                                                            <div className="col-md-3 plNoneOrdr">
                                                                <Image
                                                                    src={shirt?.inventory_category?.inventories[0]?.image
                                                                        ? `${ImageUrl}${shirt?.inventory_category?.inventories[0]?.image}`
                                                                        : "/assets/images/no-photo.png"}
                                                                    className="selectCoatImgReview"
                                                                    alt=""
                                                                />
                                                            </div>
                                                            <div className="col-md-9 pRNoneOrdr">
                                                                <div className="row">
                                                                    <div className="col-md-10">
                                                                        <ul className="fstCategory mb-2 brTopNone pt-0">
                                                                            <li className="coatInfoSize">
                                                                                <span>Shirt:</span> {shirt?.style ? shirt?.style : "N/A"} {shirt?.inventory_category?.inventories[0]?.description}
                                                                            </li>
                                                                        </ul>
                                                                    </div>
                                                                    <div className="col-md-4">
                                                                        <ul className="fstCategory mb-2 brTopNone pt-0">
                                                                            <li className="coatInfoSize">
                                                                                <span>Size:</span> {shirt?.shirt_size ? shirt?.shirt_size : "N/A"
                                                                                }
                                                                            </li>
                                                                        </ul>
                                                                    </div>
                                                                    <div className="col-md-4">
                                                                        <ul className="fstCategory mb-2 brTopNone pt-0">
                                                                            <li className="coatInfoSize">
                                                                                <span>Neck:</span> {shirt?.size ? shirt?.size : "N/A"}
                                                                            </li>
                                                                        </ul>
                                                                    </div>
                                                                    <div className="col-md-4">
                                                                        <ul className="fstCategory mb-2 brTopNone pt-0">
                                                                            <li className="coatInfoSize">
                                                                                {/* <span>Sleeve:</span> {shirt?.sleeve ? shirt?.sleeve : "N/A"} */}
                                                                                <span>Sleeve:</span> {
                                                                                    shirt?.sleeve
                                                                                        ? `${shirt.sleeve}/${Number(shirt.sleeve) + 1}`
                                                                                        : "N/A"
                                                                                }
                                                                            </li>
                                                                        </ul>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                }

                                                {
                                                    vest &&
                                                    <div className="eventDetailBox posRealtive">
                                                        <div className="row">
                                                            <div className="col-md-3 plNoneOrdr">
                                                                <Image
                                                                    src={vest?.inventory_category?.inventories[0]?.image
                                                                        ? `${ImageUrl}${vest?.inventory_category?.inventories[0]?.image}`
                                                                        : "/assets/images/no-photo.png"}
                                                                    className="selectCoatImgReview"
                                                                    alt=""
                                                                />
                                                            </div>
                                                            <div className="col-md-9 pRNoneOrdr">
                                                                <div className="row">
                                                                    <div className="col-md-10">
                                                                        <ul className="fstCategory mb-2 brTopNone pt-0">
                                                                            <li className="coatInfoSize">
                                                                                <span>Vest:</span> {vest?.style ? vest?.style : "N/A"} {vest?.inventory_category?.inventories[0]?.description} {styleComments?.v}
                                                                            </li>
                                                                        </ul>
                                                                    </div>
                                                                    <div className="col-md-4">
                                                                        <ul className="fstCategory mb-2 brTopNone pt-0">
                                                                            <li className="coatInfoSize">
                                                                                <span>Size:</span> {vest?.size ? vest?.size : "N/A"}
                                                                            </li>
                                                                        </ul>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                }

                                                {(tie || shoes || jewellery || pocketSquare) && (
                                                    <>
                                                        <h5>Additional Accessories</h5>
                                                        <div className="row">
                                                            <div className="col-md-12">
                                                                <div className="othderDetailBox posRealtive">
                                                                    <div className="row">
                                                                        <div className="col-md-12">
                                                                            {tie && (
                                                                                <ul className="fstCategory-shirt">
                                                                                    <li className="whitTxtDetail">
                                                                                        <span>Tie:</span> {tie?.style ? tie?.style : "N/A"} {tie?.inventory_category?.inventories[0]?.description} {styleComments?.t}
                                                                                    </li>
                                                                                    <li>
                                                                                        <span>Size:</span> {data?.order_for}
                                                                                    </li>
                                                                                </ul>
                                                                            )}

                                                                            {shoes && (
                                                                                <ul className="fstCategory-shirt">
                                                                                    <li className="whitTxtDetail">
                                                                                        <span>Shoe:</span> {shoes?.style ? shoes?.style : "N/A"} {shoes?.inventory_category?.inventories[0]?.description}
                                                                                    </li>
                                                                                    <li>
                                                                                        <span>Size:</span> {shoes?.size ? shoes?.size : "N/A"}
                                                                                    </li>
                                                                                </ul>
                                                                            )}

                                                                            {jewellery && (
                                                                                <ul className="fstCategory-shirt">
                                                                                    <li className="whitTxtDetail">
                                                                                        <span>Jewelry:</span> {jewellery?.style ? jewellery?.style : "N/A"} {jewellery?.inventory_category?.inventories[0]?.description}
                                                                                    </li>
                                                                                </ul>
                                                                            )}

                                                                            {pocketSquare && (
                                                                                <ul className="fstCategory-shirt borderMarginNone">
                                                                                    <li className="whitTxtDetail">
                                                                                        <span>Pocket Square:</span> {pocketSquare?.style ? pocketSquare?.style : "N/A"} {pocketSquare?.inventory_category?.inventories[0]?.description}
                                                                                    </li>
                                                                                </ul>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </>
                                                )}


                                                <hr></hr>
                                                <div className="row mt-3">
                                                    <div className="col-md-12">
                                                        <h5>Audit Log</h5>
                                                        <div className="table-responsive tableScroll" id="style-14">
                                                            <table className="table table-striped">
                                                                <thead>
                                                                    <tr>
                                                                        <th scope="col">Date/Time</th>
                                                                        <th scope="col">User Name</th>
                                                                        <th scope="col">Change Type</th>
                                                                        <th scope="col">Previous Value</th>
                                                                        <th scope="col">New Value</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {data?.logs?.length > 0 ? (

                                                                        data.logs.map((data) => (
                                                                            <tr key={data.id || data.createdAt}>
                                                                                <th scope="row">
                                                                                    {moment(data?.createdAt).format("MMM D, YYYY, h:mm A")}
                                                                                </th>
                                                                                {/* <td>{data?.user?.firstName} {data?.user?.lastName}</td> */}
                                                                                <td>
                                                                                    {data?.user_name ?? `${data?.user?.firstName ?? ""} ${data?.user?.lastName ?? ""}`}
                                                                                </td>

                                                                                <td>{data?.change_type}</td>
                                                                                <td>
                                                                                    {data?.previous_data
                                                                                        ? data.previous_data.includes("XL")
                                                                                            ? data.previous_data.replace("XL", "X")
                                                                                            : (() => {
                                                                                                // First check if it's a number that's too small to be a real date
                                                                                                if (!isNaN(data.previous_data) && Number(data.previous_data) < 1000) {
                                                                                                    return data.previous_data;
                                                                                                }

                                                                                                const date = new Date(data.previous_data);
                                                                                                // Check if it's a valid date AND the year is reasonable
                                                                                                if (date instanceof Date && !isNaN(date.getTime()) && date.getFullYear() > 1900 && date.getFullYear() < 2100) {
                                                                                                    // Format as MM/DD/YYYY
                                                                                                    return `${String(date.getMonth() + 1).padStart(2, "0")}/${String(date.getDate()).padStart(2, "0")}/${date.getFullYear()}`;
                                                                                                } else {
                                                                                                    // If not a valid date, show the original value
                                                                                                    return data.previous_data;
                                                                                                }
                                                                                            })()
                                                                                        : "N/A"}
                                                                                </td>

                                                                                <td>
                                                                                    {data?.new_data
                                                                                        ? data.new_data.includes("XL")
                                                                                            ? data.new_data.replace("XL", "X")
                                                                                            : (() => {
                                                                                                // First check if it's a number that's too small to be a real date
                                                                                                if (!isNaN(data.new_data) && Number(data.new_data) < 1000) {
                                                                                                    return data.new_data;
                                                                                                }

                                                                                                const date = new Date(data.new_data);
                                                                                                // Check if it's a valid date AND the year is reasonable
                                                                                                if (date instanceof Date && !isNaN(date.getTime()) && date.getFullYear() > 1900 && date.getFullYear() < 2100) {
                                                                                                    // Format as MM/DD/YYYY
                                                                                                    return `${String(date.getMonth() + 1).padStart(2, "0")}/${String(date.getDate()).padStart(2, "0")}/${date.getFullYear()}`;
                                                                                                } else {
                                                                                                    // If not a valid date, show the original value
                                                                                                    return data.new_data;
                                                                                                }
                                                                                            })()
                                                                                        : "N/A"}
                                                                                </td>
                                                                            </tr>
                                                                        ))
                                                                    ) : (
                                                                        <tr>
                                                                            <td colSpan="5" className="text-center">    <div className="data-not-found">
                                                                                <em className="icon ni ni-info"></em>
                                                                                <p>No data available</p>
                                                                            </div></td>
                                                                        </tr>
                                                                    )}
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <Modal
                    title="Exchange Order Detail"
                    open={isExchangeModalOpen}
                    onCancel={() => setIsExchangeModalOpen(false)}
                    footer={null}
                    width={1200}
                    centered
                    style={{
                        left: "180px",
                        top: 0,
                        padding: 0,
                        margin: 0,
                    }}
                >
                    <div className="table-responsive">
                        <table className="table table-bordered">
                            <thead>
                                <tr>
                                    <th>Exchange Order</th>
                                    <th colSpan="3">Coat</th>
                                    <th colSpan="3">Pant</th>
                                    <th colSpan="4">Shirt</th>
                                    <th colSpan="2">Vest</th>
                                    <th>Tie</th>
                                    <th colSpan="2">Shoe</th>
                                    <th>Jewelry</th>
                                    <th>Pocket Square</th>
                                </tr>
                                <tr>
                                    <th></th>
                                    <th>Style</th>
                                    <th>Size</th>
                                    <th>Insleeve</th>

                                    <th>Waist</th>
                                    <th>Outseam</th>
                                    <th>Hip</th>

                                    <th>Style</th>
                                    <th>Shirt Size</th>
                                    <th>Neck</th>
                                    <th>Sleeve</th>

                                    <th>Style</th>
                                    <th>Size</th>

                                    <th>Style</th>

                                    <th>Style</th>
                                    <th>Size</th>

                                    <th>Style</th>

                                    <th>Style</th>
                                </tr>
                            </thead>

                            <tbody>
                                {exchangeOrders.length > 0 ? (
                                    exchangeOrders.map((order, index) => {

                                        return (
                                            <tr key={order.id || index}>
                                                <td>{order.exchange_ord || order.order_number || "N/A"}</td>

                                                {/* Coat */}
                                                <td>{order.coat || "N/A"}</td>
                                                <td>{order.coat_size || "N/A"}</td>
                                                <td>{order?.coat_sleeve || "N/A"}</td>

                                                {/* Pant */}
                                                <td>{order?.waist || "N/A"}</td>
                                                <td>{order?.outseam || "N/A"}</td>
                                                <td>{order?.hip || "N/A"}</td>

                                                {/* Shirt */}
                                                <td>{order?.shirt || "N/A"}</td>
                                                <td>{order?.shirt_size || "N/A"}</td>
                                                <td>{order?.shirt?.neck || "N/A"}</td>
                                                <td>
                                                    {order?.sleeve
                                                        ? `${order.sleeve}/${Number(order.sleeve) + 1}`
                                                        : "N/A"}
                                                </td>

                                                {/* Vest */}
                                                <td>{order?.vest || "N/A"}</td>
                                                <td>{order?.vest_size || "N/A"}</td>

                                                {/* Tie */}
                                                <td>{order?.tie || "N/A"}</td>

                                                {/* Shoe */}
                                                <td>{order?.shoes || "N/A"}</td>
                                                <td>{order?.shoe_size || "N/A"}</td>

                                                {/* Jewelry */}
                                                <td>{order?.jewel || "N/A"}</td>

                                                {/* Pocket Square */}
                                                <td>{order?.pocket_square || "N/A"}</td>
                                            </tr>
                                        );
                                    })
                                ) : (
                                    <tr>
                                        <td colSpan="18" className="text-center">
                                            <div className="data-not-found">
                                                <em className="icon ni ni-info"></em>
                                                <p>No exchange orders available</p>
                                            </div>
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </Modal>

            </Container >
        </>
    );
}
export default OrderDetail;
